<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 24 }">
      <a-col :xs="24" :lg="12">
        <div>
          <table>
            <tr>
              <td class="td-information">TLC</td>
              <td class="td-information">:</td>
              <td class="td-information">{{ getAuth.username }}</td>
            </tr>
            <tr v-if="dataProfile.employee">
              <td class="td-information">Jabatan</td>
              <td class="td-information">:</td>
              <td class="td-information">
                {{
                  dataProfile.employee.nama_jabatan
                    ? dataProfile.employee.nama_jabatan
                    : "-"
                }}
              </td>
            </tr>
            <tr v-if="dataProfile.employee">
              <td class="td-information">Unit Kerja</td>
              <td class="td-information">:</td>
              <td class="td-information">
                {{ dataProfile.employee.nama_dept }}
              </td>
            </tr>
            <tr>
              <td class="td-information">Efective Date</td>
              <td class="td-information">:</td>
              <td class="td-information">
                {{ displayDate }}
              </td>
            </tr>
          </table>
        </div>
      </a-col>
      <a-col :xs="24" :lg="12">
        <div style="display:flex;align-items: center;">
          <span style="padding-right:5px">Periode : </span>
          <a-month-picker
            v-model="currentDate"
            @change="formatDate"
            :allowClear="false"
          />
        </div>
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "InformationCreateKPI",
  props: ["data"],
  data() {
    return { currentDate: moment(), dataProfile: {}, displayDate: "" };
  },
  computed: {
    ...mapGetters(["getAuth"])
  },
  mounted() {
    this.fetching();
    this.formatDate(moment());
  },
  methods: {
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "master_karyawan",
        params: {
          tlc: this.getAuth.username,
          tlc_login: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.dataProfile = response.data;
        })
        .catch(err => {
          if (err.response.data.message == "invalid access") {
            this.isAllowed = false;
          }
        });
    },
    formatDate(date) {
      const format = "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ";
      const myDate = moment(date, format);
      const currentMonth = myDate.format("MMMM");
      const nextMonth = myDate
        .clone()
        .add(1, "month")
        .format("MMMM");
      const currentYear = myDate.format("YYYY");

      const formatDate = `28-${currentMonth}-${currentYear} s/d 27-${nextMonth}-${currentYear}`;
      this.displayDate = formatDate;
    }
  }
};
</script>

<style scoped>
.td-information {
  padding: 10px;
}
</style>
